<script>
export default {
  name: "IndexView",
  data() {
    return {
      logo: require("../assets/xiehui.png"),
      title: "智慧监管",
      dialogTitle:'',
      DialogVisible:false,
      menuList: [],
      levelList: [],
      formData: {
        userId: '',
        onePassword: '',
        twoPassword: '',
        oldPassword: ''
      },
      formRef: {
        oldPassword: [
          {
            required: true,
            trigger: 'blur',
            message: '原密码不能为空'
          }
        ],
        onePassword: [
          {
            required: true,
            trigger: 'blur',
            message: '新密码不能为空'
          }
        ],
        twoPassword: [
          {
            required: true,
            trigger: 'blur',
            message: '确认密码不能为空'
          }
        ],
      },
      id: '',
      isOpen: false,
      activeIndex: this.$route.path,
      headerIcon: "el-icon-s-fold",
      screenHeight: document.documentElement.clientHeight + "px",
    };
  },
  created() {
    this.id = window.localStorage.getItem("id");
    this.username = "欢迎您," + window.localStorage.getItem("username");
    this.menuList = this.getMenuList();
  },
  methods: {

    handleCancel() {
      this.DialogVisible = false
    },
    closeDialog() {
      this.DialogVisible = false
    },
    getMenuList() {
      const that = this;
      const data = {
        id: that.id,
      };
      // let arr = this.getPath(this.$router.options.routes)
      that.$axios
          .post("menu/user/list", data)
          .then(function (res) {
            if (res.data.code === 200) {
              let menuList = res.data.data
              that.menuList = menuList;
              that.getBreadcrumb(menuList)
            } else {
              this.$message({
                type: "info",
                message: res.data.message,
              });
            }
          })
    },
    handleOpenMenu() {
      this.isOpen === false ? (this.isOpen = true) : (this.isOpen = false);
      this.headerIcon === "el-icon-s-fold"
          ? (this.headerIcon = "el-icon-s-unfold")
          : (this.headerIcon = "el-icon-s-fold");
    },
    handleEdit() {
      this.dialogTitle = '修改密码'
      this.DialogVisible = true
      this.id = window.localStorage.getItem("id")
    },
    updatePassword() {
      const _this = this
      const data = {
        userId: _this.id,
        oldPassword:_this.formData.oldPassword,
        onePassword: _this.formData.onePassword,
        twoPassword: _this.formData.twoPassword
      }
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.$axios.post('user/update/password', data).then(function (res) {
            if(res.data.code === 200){
              _this.$message({
                type: 'success',
                message: res.data.msg
              })
              _this.DialogVisible = false
              window.localStorage.removeItem("id");
              window.localStorage.removeItem("username");
              window.localStorage.removeItem("token");
              _this.$router.push({path: "/"});
            }
            else{
              _this.$Message.error(res.data.msg)
            }
          }).catch(function (err) {
            _this.$Message.error(err)
          })
        }
      });
    },
    logout() {
      const _this = this;
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        window.localStorage.removeItem("id");
        window.localStorage.removeItem("username");
        window.localStorage.removeItem("token");
        _this.$router.push({path: "/"});
      })
          .catch(() => {
          });
    },
    handleLink(item) {
      this.$router.push(item.url)
    },
    changeLevelList(item) {
      this.levelList = item
    },

    getBreadcrumb(menuList) {
      let matched = this.$route.path
      let _this = this
      menuList.forEach(items => {
        items.children.forEach(item => {
          if (matched == item.url) {
            _this.levelList = item
          }
        })
      })
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
    }
  },
}
</script>

<template>
  <div class="home" style="height: 100%">
    <el-container style="height: 100%; overflow: hidden">
      <el-aside width="auto">
        <el-scrollbar wrap-class="scrollbar-wrapper" style="height: 100%">
          <div class="sidebar-logo-container" :class="{ collapse: isOpen }">
            <transition name="sidebarLogoFade">
              <div v-if="isOpen" key="collapse" class="sidebar-logo-link">
                <img v-if="logo" :src="logo" class="sidebar-logo"/>
                <h1 v-else class="sidebar-title">{{ title }}</h1>
              </div>
              <div v-else key="expand" class="sidebar-logo-link">
                <img v-if="logo" :src="logo" class="sidebar-logo"/>
                <h1 class="sidebar-title">{{ title }}</h1>
              </div>
            </transition>
          </div>
          <el-menu class="el-menu-vertical-demo" :collapse="isOpen" :default-active="activeIndex" :unique-opened="true" background-color="#1A7AF8" text-color="white" active-text-color="white" router>
            <el-submenu :index="item.id" v-for="item in menuList" :key="item.id">
              <template  slot="title">
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item v-for="items in item.children" :key="items.id" :index="items.url" @click="changeLevelList(items)">
                <i :class="items.icon"></i>
                <span>{{ items.name }}</span>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-scrollbar>
      </el-aside>
      <el-container>
        <el-header class="flex">
          <i :class="headerIcon" @click="handleOpenMenu"></i>
          <el-breadcrumb v-if="levelList.length!=0" class="app-breadcrumb" separator="/">
            <transition name="breadcrumb">
              <el-breadcrumb-item>
                <a>{{ levelList.parentName }}</a>
              </el-breadcrumb-item>
            </transition>
            <transition name="breadcrumb">
              <el-breadcrumb-item>
                <a>{{ levelList.name }}</a>
              </el-breadcrumb-item>
            </transition>
          </el-breadcrumb>
          <div style="flex: 1; text-align: end">
            <span class="username" style="margin-right: 20px">{{
                username
              }}</span>
            <el-button size="mini" type="danger" @click="handleEdit">修改密码</el-button>
            <el-button size="mini" type="danger" @click="logout">退出</el-button>
          </div>
        </el-header>
        <el-scrollbar style="height:100%;">
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>

    <el-dialog :title="dialogTitle" :visible.sync="DialogVisible" width="50%" center @close='closeDialog'>
      <el-form :model="formData" :rules="formRef"  ref="formData" label-width="110px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input type="password" v-model="formData.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="onePassword">
          <el-input type="password" v-model="formData.onePassword"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="twoPassword">
          <el-input type="password" v-model="formData.twoPassword"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleCancel">取 消</el-button>
    <el-button type="primary" @click="updatePassword('formData')">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<style>
.flex {
  display: flex;
  align-items: center;
}
.el-submenu__title i{
  color: white !important;
}

.el-menu-item.is-active {
  background-color: rgb(0, 144, 255) !important;
  color: #fff;
}
.el-menu-item i{
  color: white !important;
}
.el-menu {
  border-right: 0px !important;
}
.
.el-container {
  border: 0px !important;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-input-number.is-without-controls .el-input__inner{
  padding-left: 0;
  padding-right: 0;
  text-align: left;
}
.el-header {
  width: 100%;
  background-color: #f2f2f2;
  color: #333;
  line-height: 60px;
  padding: 0 20px;
  border-bottom: 2px solid #f6f6f6;
}

.el-header i {
  font-size: 20px;
  cursor: pointer;
}

.el-header span {
  cursor: pointer;
}

.el-aside {
  color: #333;
  background-color: #1A7AF8;
}

.el-main {
  color: #333;
  /*text-align: center;*/
}

.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: calc(100% - 40px);
  height: 50px;
  padding: 0 20px;
  line-height: 50px;
  background: #1A7AF8;
  text-align: center;
  overflow: hidden;
}

.sidebar-logo-container .sidebar-logo-link {
  height: 100%;
  width: 100%;
}

.sidebar-logo-container .sidebar-logo {
  width: 32px;
  height: 32px;
  vertical-align: middle;
  margin-right: 12px;
  border-radius: 50%;
}

.sidebar-logo-container .sidebar-title {
  display: inline-block;
  margin: 0;
  color: #fff;
  font-weight: 600;
  line-height: 50px;
  font-size: 14px;
  font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
  vertical-align: middle;
}

.collapse .sidebar-logo {
  margin-right: 0px;
}

.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;
}
.el-breadcrumb__inner{
  color: #303133 !important;
}
.no-redirect {
  color: #97a8be;
  cursor: text;
}

/* 隐藏x轴的滚动条  导致影响select下拉框显示问题 */
.el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}

/* 解决隐藏X轴滚动条后select下拉框显示不完整的bug */
.el-select-dropdown .el-scrollbar {
  padding-bottom: 17px;
}
.home{
  background-color: white;
}
</style>
